import { apiRequest } from './apiClient';

const BASE_URL = '/admin/api/reviewer';

export const reviewerService = {
  // Get all events for reviewer
  getEvents: async () => {
    return await apiRequest({
      endpoint: `${BASE_URL}/events`,
      method: 'GET',
      auth: true
    });
  },

  // Get quizzes by event
  getQuizzesByEvent: async (eventId) => {
    return await apiRequest({
      endpoint: `${BASE_URL}/events/${eventId}/quizzes`,
      method: 'GET',
      auth: true
    });
  },

  // Get users by quiz
  getUsersByQuiz: async (quizId, page = null, limit = null) => {
    let endpoint = `${BASE_URL}/quizzes/${quizId}/users`;

    const params = new URLSearchParams();
    if (page !== null && page !== undefined) params.append('page', page.toString());
    if (limit !== null && limit !== undefined) params.append('limit', limit.toString());
    if (params.toString()) endpoint += `?${params.toString()}`;

    return await apiRequest({
      endpoint,
      method: 'GET',
      auth: true
    });
  },

  // Get answers by quiz and user
  getAnswersByQuizUser: async (quizId, userId) => {
    return await apiRequest({
      endpoint: `${BASE_URL}/quizzes/${quizId}/users/${userId}/answers`,
      method: 'GET',
      auth: true
    });
  },

  // Grade an answer sheet
  gradeAnswer: async (answerSheetId, points, reviewerNotes) => {
    return await apiRequest({
      endpoint: `${BASE_URL}/answer-sheets/${answerSheetId}/grade`,
      method: 'PATCH',
      body: {
        points: points,
        reviewer_notes: reviewerNotes
      },
      auth: true,
      showSuccess: false // We'll handle success messages manually
    });
  }
};

export default reviewerService;
